import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/settings/permission-and-roles/')({
  beforeLoad() {
    throw redirect({ to: '/settings/permission-and-roles/roles' });
  },
});
